export default __webpack_public_path__ + "static/media/03Tireli60s.39496ede.mp3";